
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { ObjetoTitulo } from '../../framework/angular/dominio/ObjetoTitulo';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@env/appconfig';


@Injectable()
export class ServicioGlobalService {
    constructor(private http: HttpClient, private config: AppConfig) { }

    public itemsSource = new Subject<ObjetoTitulo>();
    public bloqueoSource = new Subject<Boolean>();
    public breadSource = new Subject<MenuItem[]>();
    public breadSourceMovil = new Subject<MenuItem[]>();
    public breadIconSource = new Subject<MenuItem>();

    itemsHandler = this.itemsSource.asObservable();
    bloqueoHandler = this.bloqueoSource.asObservable();
    breadHandler = this.breadSource.asObservable();
    breadHandlerMovil = this.breadSourceMovil.asObservable();
    breadIconHandler = this.breadIconSource.asObservable();

    setItems(items: ObjetoTitulo) {
        this.itemsSource.next(items); 
    }   
    
    setBloqueo(bloqueo: boolean) {
        this.bloqueoSource.next(bloqueo); 
    }   

    setBread(bread: MenuItem[], breadMovil: MenuItem[]){
        this.breadSource.next(bread);
        this.breadSourceMovil.next(breadMovil);
    }

    setBreadIcon(icon: MenuItem){
        this.breadIconSource.next(icon);
    }
}
   